<template>
  <van-tabbar
    :value="active"
    :safe-area-inset-bottom="true"
    class="slider-tabbar"
    active-color="#279754"
    inactive-color="#8c8c8c"
    @change="changeActive"
    route
  >
    <van-tabbar-item to="/home">
      <div class="tabbar-item">
        <img
          v-show="active !== 0"
          src="/official_mobile/static/img/home/home_01.png"
          alt="home1"
        >
        <img
          v-show="active === 0"
          src="/official_mobile/static/img/home/home_02.png"
          alt="home2"
        >
        {{ $t('common.p2') }}
      </div>
    </van-tabbar-item>
    <van-tabbar-item to="/ppwc">
      <div class="tabbar-item">
        <img
          v-show="active !== 1"
          src="/official_mobile/static/img/home/events_01.png"
          alt="events_01"
        >
        <img
          v-show="active === 1"
          src="/official_mobile/static/img/home/events_02.png"
          alt="events_02"
        >
        {{ $t('common.p3') }}
      </div>
    </van-tabbar-item>
    <van-tabbar-item to="/blog">
      <div class="tabbar-item">
        <img
          v-show="active !== 2"
          src="/official_mobile/static/img/home/blog_01.png"
          alt="blog"
        >
        <img
          v-show="active === 2"
          src="/official_mobile/static/img/home/blog_02.png"
        >
        {{ $t('common.p6') }}
      </div>
    </van-tabbar-item>
    <!-- <van-tabbar-item to="/faq">
      <div class="tabbar-item">
        <img v-show="active !== 3" src="/official_mobile/static/img/home/faq_01.png" />
        <img v-show="active === 3" src="/official_mobile/static/img/home/faq_02.png" />
        {{ $t('common.p7') }}
      </div>
    </van-tabbar-item> -->
  </van-tabbar>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      // active: this.$store.state.tab
    }
  },
  computed: {
    active () {
      return this.$store.state.tab
    }
  },
  created () {
    // this.active = this.$store.state.tab
  },
  methods: {
    changeActive (active) {
      this.$store.commit('changeTab', active)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.slider-tabbar {
  height: 100px;
  background-color: #000000;
  color: #8c8c8c;
  font-size: 20px;
  @media only screen and (min-width: 10rem) {
    width: 10rem;
    left: 50%;
    margin-left: -5rem;
  }
  .tabbar-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    img {
      height: 44px;
      display: block;
      margin-bottom: 5px;
    }
  }
}
.slider-tabbar.van-hairline--top-bottom::after, .slider-tabbar.van-hairline-unset--top-bottom::after {
  border: none;
}
</style>
